import commitMutation from 'relay-commit-mutation-promise';
import { graphql } from 'react-relay';

const mutation = graphql`
    mutation ModifyFollowingItems_esMutation($input: FavoritePageInput!) {
        favoritePage(input: $input) {
            user {
                favorites {
                    totalResults
                    numberOfPages
                }
            }
        }
    }
`;

function getVariables(args) {
    const { type, userId, query, page, favoriteId, action } = args;
    return {
        action,
        userId,
        query,
        page,
        type,
        favoriteId,
    };
}

function getConfigs(userId) {
    return [
        {
            type: 'FIELDS_CHANGE',
            fieldIDs: {
                user: userId,
            },
        },
    ];
}

function commit(environment, args) {
    const configs = getConfigs(args.userId);
    const variables = {
        input: getVariables(args),
    };
    return commitMutation(environment, {
        mutation,
        variables,
        configs,
    });
}

export default { commit };
